import React from 'react';
import { AppCard } from '@/components/app-card/app-card';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import {
  calculateDepartmentBudgetAllocationPercentage,
  calculateTotalAllocatedFromDepartmentBudget,
  calculateUnallocatedDepartmentPercentage,
  calculateUnallocatedFromDepartmentBudget,
  SystemData,
} from '../../calculations';
import { Stack, TextField } from '@mui/material';

interface DepartmentBudgetCardProps {
  items: SystemData[];
  selectedDepartmentId: string;
  departmentBudgets: Map<
    number,
    { value: number; currency: string; name: string }
  >;
  getUserDepartmentBudget: () => {
    value: string;
    currency: string;
    name: string;
  };
}

export const DepartmentBudgetCard: React.FC<DepartmentBudgetCardProps> = ({
  items,
  selectedDepartmentId,
  departmentBudgets,
  getUserDepartmentBudget,
}) => {
  return (
    <AppCard
      className="card100"
      title={`Department Budget Allocation - ${getUserDepartmentBudget().name}`}
      icon={<BarChartOutlinedIcon color="primary" />}>
      <Stack spacing={2}>
        <Stack spacing={2} direction="row">
          <TextField
            label="Annual Department Budget"
            variant="outlined"
            disabled
            size="small"
            value={getUserDepartmentBudget().value}
          />

          <TextField
            label="Budget Currency"
            variant="outlined"
            disabled
            size="small"
            value={getUserDepartmentBudget().currency}
          />
        </Stack>

        <Stack spacing={2} direction="row">
          <TextField
            label="Allocated"
            variant="outlined"
            disabled
            size="small"
            value={calculateTotalAllocatedFromDepartmentBudget(
              items,
              selectedDepartmentId,
            )}
          />

          <TextField
            label="Budget Allocation"
            variant="outlined"
            disabled
            size="small"
            value={calculateDepartmentBudgetAllocationPercentage(
              items,
              selectedDepartmentId,
              departmentBudgets,
            )}
          />
        </Stack>

        <Stack spacing={2} direction="row">
          <TextField
            label="Unallocated"
            variant="outlined"
            disabled
            size="small"
            value={calculateUnallocatedFromDepartmentBudget(
              items,
              selectedDepartmentId,
              departmentBudgets,
            )}
          />

          <TextField
            label="Missing Allocation"
            variant="outlined"
            disabled
            size="small"
            value={calculateUnallocatedDepartmentPercentage(
              items,
              selectedDepartmentId,
              departmentBudgets,
            )}
          />
        </Stack>
      </Stack>
    </AppCard>
  );
};
